import { useEffect } from 'react';
import { Text } from 'ink';

import { deleteAuthConfig } from '../utilities/configStore';
import ErrorBoundary from '../components/ErrorBoundary';
import LoginHOC from '../components/LoginHOC';
import { useAnalyticsCommand } from '../utilities/useAnalytics';
import useExit from '../utilities/useExit';

function Logout() {
  const exit = useExit();
  const { hasAttemptedTracking } = useAnalyticsCommand('logout');

  // delete auth config deletes the credentials stored on disk
  deleteAuthConfig();

  // exits the program once tracking of the "logout" command has been attempted
  useEffect(() => {
    if (hasAttemptedTracking) {
      exit();
    }
  }, [exit, hasAttemptedTracking]);

  return <Text>Log out successful</Text>;
}

export default function LogoutWrapper() {
  return (
    <ErrorBoundary>
      <LoginHOC isInteractive={false}>
        <Logout />
      </LoginHOC>
    </ErrorBoundary>
  );
}
